import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './fr.json';
import en from './en.json';

const STORAGE_KEY = 'secuguard_lang';

i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    en: { translation: en },
  },
  lng: localStorage.getItem(STORAGE_KEY) || 'fr',
  fallbackLng: 'fr',
  interpolation: {
    escapeValue: false,
  },
});

// Persist language choice.
i18n.on('languageChanged', (lng) => {
  localStorage.setItem(STORAGE_KEY, lng);
});

export default i18n;
